<template>
  <KPICard
    v-for="(measurement, i) in measurements"
    :key="i"
    :title="measurement.title[locale]"
    :kpiInfo="measurement.info?.[locale]"
    :fullscreen="sharedData?.fullscreen ?? false"
    :dataSource="measurement.props.dataSource"
    :kpiFormat="measurement.props.format"
    :metadataFormat="measurement.props.metadataFormat"
    :metadataLabels="measurement.props.metadataLabels"
    :color="measurement.props.color"
    :colorScale="measurement.props.colorScale"
    :first="i === 0"
    :isLoading="false"
    :showOnMap="false"
    :showOnMapEnabled="true"
  />
</template>

<script setup lang="ts">
import { LocaleString } from '@/api-client/models/utilization/Contracts'
import KPICard from '../components/cards/KPICard.vue'
import { sharedDataKey } from '../../types'
import { inject } from 'vue'
import { useI18n } from 'vue-i18n'
import { FormatOptions } from '../formatter'
import { ColorScaleConfig } from '@/utils/colorScale'

export type Measurement = {
  title: LocaleString
  info: LocaleString
  props: {
    color: string
    colorScale: ColorScaleConfig
    format: FormatOptions
    metadataFormat?: Record<string, FormatOptions>
    metadataLabels?: Record<string, LocaleString>
    dataSource: string
  }
}

type Props = {
  measurements: Measurement[]
}

defineProps<Props>()

const { locale } = useI18n()

const sharedData = inject(sharedDataKey)
</script>
